import React, { useEffect, useState, forwardRef, useImperativeHandle, useMemo, useContext } from 'react';
import { Avatar, Badge, Breadcrumb, Button, Card, Checkbox, Col, Divider, Drawer, Flex, Form, Input, Layout, List, message, notification, Popconfirm, Row, Select, Steps, Table, Tabs, Tag, theme, Tooltip, Typography, Upload } from 'antd';
import { AppstoreOutlined, DeleteOutlined, PlusOutlined, MenuOutlined, HolderOutlined } from '@ant-design/icons';
import { DndContext, closestCenter } from "@dnd-kit/core";
import { SortableContext, useSortable, arrayMove, verticalListSortingStrategy, } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useSelector } from 'react-redux';
import RequestApproval from '../../../restAPI/RequestApproval';
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { permission } from 'process';
import CommonSkeletonLoader from '../../../helperComponents/CommonSkeleton';


const { Option } = Select;
const { Text } = Typography;


const CreateTeam = forwardRef(({ setTeam, initialTeam, showTeamNameField, drawerClose, selectTeam, hocusers }, ref) => {
    const { companyId, token, userCompany, role, userId } = useSelector(state => state.auth);
    // const [open, setOpen] = useState(false);
    const [desableCircularType, setDesableCircularType] = useState(false);

    const [count, setCount] = useState(0);
    // const [showInput, setShowInput] = useState(false); // State to track checkbox
    const [circularTypeFilter, setCircularTypeFilter] = useState(""); // State to track checkbox

    const [companyTeams, setCompanyTeams] = useState([]);
    const [companyTeamsBackup,setCompanyTeamsBackup] = useState([]);

    const [selectedTeams, setSelectedTeams] = useState(selectTeam);
    const [teams, setTeams] = useState([]);
    const [members, setMembers] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [availableUsers, setAvailableUsers] = useState([]);
    const [hocUserLists, setHocUserLists] = useState(hocusers);
    const [isMembersTableLoading, setIsMembersTableLoading] = useState(false);
    const [form] = Form.useForm();
    const RowContext = React.createContext({});


    if (selectTeam !== null) {


    }




    RequestApproval.testWithJWTandCID(companyId, token);


    const [teamCreate, setTeamCreate] = useState(initialTeam)


    const [api, contextHolder] = notification.useNotification();
    const openNotification = (type, message, description, placement) => {
        api[type]({
            message: message,
            description: description,
            placement
        });
    };






    // if(initialTeam !== null){
    //     // const valll = JSON.parse(initialTeam);
    //     console.log(initialTeam, "initialTeam mmmmmmmmmmmm")
    //     // setTeamCreate(initialTeam)
    // }
    // members: [


    //     {
    //         branchId: "668e398479e6ddd2dd6586d7",
    //         position: 2,
    //         approverId: "6671283d1f05a4fc64a4af6a",
    //         hocId: "667127f71f05a4fc64a4af60",
    //         permission: "view"
    //     }
    // ]


    useImperativeHandle(ref, () => ({
        async CreateTeam() {


            //setData(fileList);
            const value = await validateTeam();


            let stt = false;
            if (value.status) {
                // console.log(teamCreate,"CreateTeam CreateTeam function")
                stt = await saveTeam(value.teamObj);
                if (stt) {
                    // setTeamCreate({
                    //     name: "",
                    //     companyId : companyId,
                    //     circulationType: "",
                    //     members: []
                    // })
                    drawerClose();
                }


            }
            return stt
        },
        async EditeTeam() {
            const value = await validateTeam();


            let stt = false;
            if (value.status) {
                // console.log(teamCreate,"CreateTeam CreateTeam function")
                stt = await updateTeam(value.teamObj);
                if (stt) {


                    // setTeamCreate({
                    //     name: "",
                    //     companyId : companyId,
                    //     circulationType: "",
                    //     members: []
                    // })
                    drawerClose();
                }
            }
            return stt
        },
        async validateWorkflow() {
            const value = await validateTeam();


            if (value.status) {
                let backupTeam = { ...teamCreate }
                backupTeam.members = members
                let returnValue = {
                    createdTeam: backupTeam,
                    selectedTeams: selectedTeams
                }


                return { status: true, obj: returnValue }
            }
            else {
                return { status: false, obj: null }
            }
        },
        async SelectTeamBackup() {
            let backupTeam = { ...teamCreate }
            backupTeam.members = members
            let returnValue = {
                createdTeam: backupTeam,
                selectedTeams: selectedTeams,
                hocUsers: hocUserLists
            }


            return returnValue
        }
    }));
    useEffect(() => {
    }, [teamCreate])


    useEffect(() => {
        const listOne = [...members]
        const listTwo = [...allUsers]


        const filteredList = listTwo.filter(
            (user) => !listOne.some((member) => member.approverId === user.id)
        );
        // setAvailableUsers(filteredList);
        const companyInfo = userCompany.companyData.find(company => company.companyId === companyId);
        const filteredListtwo = filteredList.filter(item => !initialTeam.members.includes(item) && item.id!==companyInfo.userDetailsId);
        setAvailableUsers(filteredListtwo);

    }, [members])


    // useEffect(()=>{
    //     console.log(selectedTeams,"selectedTeams update")
    // },[selectedTeams])


    // useEffect(()=>{
    //     console.log(companyTeams,"companyTeams update")
    // },[companyTeams])
    useEffect(() => {
        getAllTeams();
        setAllUsersFunc();
    }, [])


    const validateTeam = async () => {
        try {
            if (members.length > 0) {
                await form.validateFields(['circulertype']);
                await form.validateFields(['worflowname']);


                for (const record of members) {
                    await form.validateFields([`action${record.key}`]);
                    await form.validateFields([`approver${record.key}`]);
                }


                let validateObj = { ...teamCreate }
                validateObj.members = members;
                return { status: true, teamObj: validateObj }
            } else {
                // message.error('Team Should Have Atleast One Member!');
                openNotification('error', 'Error', `Team Should Have Atleast One Member!`, 'bottomLeft');
                return { status: false, teamObj: null };
            }
        } catch (errorInfo) {
            console.error('Validation Failed:', errorInfo);
            if (errorInfo.errorFields) {
                // Extract failed fields
                const failedFields = errorInfo.errorFields.map(field => field.name[0]);
                console.warn('Failed Fields:', failedFields);


                // Display error message
                openNotification('error', 'Validation Error', `Please confirm to select Action and Approver for each row`, 'bottomLeft');
            } else {
                openNotification('error', 'Validation Error', `Unknown validation error occurred`, 'bottomLeft');
            }
            return { status: false, teamObj: null };
        }
    }


    const saveTeam = async (teamObject) => {
        let status = false;
        await RequestApproval.createTeam(teamObject).then((response) => {


            // message.success('Team Created Successfully!');
            openNotification('success', 'Success', `Team Created Successfully`, 'bottomLeft');
            status = true;
        })
            .catch((err) => {
                if (err.response) {
                    // message.error(`${err.response.data.message}`);
                    openNotification('error', 'Error', `${err.response.data.message}`, 'bottomLeft');
                } else {
                    // message.error('Creation Faild!');
                    openNotification('error', 'Error', `Creation Failed!`, 'bottomLeft');
                }
            });


        return status
    }


    const updateTeam = async (teamObject) => {
        let status = false;
        await RequestApproval.editTeam(teamObject, selectTeam[0]._id).then((response) => {


            // message.success('Team Updated Successfully!');
            openNotification('success', 'Success', `Team Updated Successfully`, 'bottomLeft');


            status = true;
        })
            .catch((err) => {
                if (err.response) {
                    // message.error(`${err.response.data.message}`);
                    openNotification('error', 'Error', `${err.response.data.message}`, 'bottomLeft');


                } else {
                    // message.error('Update Faild!');
                    openNotification('error', 'Error', `Update Failed !`, 'bottomLeft');
                }
            });


        return status
    }


    const getAllTeams = () => {
        // console.log("Tem");setCompanyTeams
        const data = RequestApproval.getTeamsForCompany().then((data) => {
            let teams = []
            data.data.forEach((element, index) => {
                let obj = {
                    id: element._id,
                    name: element.name,
                    type: element.circulationType
                }
                teams.push(obj);
            });


            setCompanyTeams(teams);
            setCompanyTeamsBackup(teams);
            setTeams(data.data);
        });
    }


    const setAllUsersFunc = async () => {
        const data = await RequestApproval.usersByCompanyId();
        let companyUsers = []
        data.data.forEach((element, index) => {
            let obj = {
                id: element._id,
                name: `${element.name} - ${element.designation}`,
                // branchId:element.branchId._id
            }
            companyUsers.push(obj);
        });
        setAllUsers(companyUsers);
        // //setCompanyTeamsBackup(teams);
        const companyInfo = userCompany.companyData.find(company => company.companyId === companyId);
        if (initialTeam.members.length > 0) {
            const filteredList = companyUsers.filter(item => !initialTeam.members.includes(item) && item.id!==companyInfo.userDetailsId);


            setAvailableUsers(filteredList);


            const filteredInitialUsers = data.data.filter(user => initialTeam.members.some(filter => filter.approverId === user._id))
                .map(user => {
                    const filterData = initialTeam.members.find(filter => filter.approverId === user._id);
                    return { ...user, ...filterData }; // Merge user object with filterData
                });






            let currentMembers = [...members]
            // console.log(filtersaaedInitialUsers,"filteredInitsssssssssssssialUsers")
            let countIndex = count
            filteredInitialUsers.map((member, index) => {
                // console.log(member,"member filteredInitialUsers ")
                const obj = {
                    key: member.position,
                    branchId: member.branchId,
                    position: member.position,
                    approverId: member.approverId,
                    hockUserId: member.hockUserId,
                    permission: member.permission,
                    notification: member.notification,
                    approverName: `${member.name}-${member.designation}`


                }
                // console.log(obj,"obj filteredInitialUsers")
                countIndex++;
                currentMembers.push(obj);


            })
            console.log(currentMembers, "currentMembers")
            setMembers(currentMembers.sort((a, b) => a.position - b.position))
            for (const item of currentMembers) {


                await updateHocuserList(item.approverId)
            }


        } else {
            const filteredList = companyUsers.filter(item =>  item.id!==companyInfo.userDetailsId);
            setAvailableUsers(filteredList);
        }




    }


    const onchangeTeamName = (e) => {
        setTeamCreate({ ...teamCreate, name: e.target.value })
    }
    const onchangeCircularType = (e) => {
        setTeamCreate({ ...teamCreate, circulationType: e })
    }

    const onFilterCircularType=(e)=>{
        setCircularTypeFilter(e);
        if(e!=""){
            const result = companyTeamsBackup.filter(item=>item.type==e);
            setCompanyTeams(result)
        }else{
            setCompanyTeams(companyTeamsBackup)

        }
    }


    const selectWorkflow = async (e) => {
        setIsMembersTableLoading(true);
        const team = selectedTeams.filter(element => element._id === e);
        if (team.length === 0) {
            const teamsTemp = teams.filter(element => element._id === e);
            setSelectedTeams((prev) => [...prev, teamsTemp[0]]);
            const currentMembers = [...members]
            const selectedTeamMembers = teamsTemp[0].members
            // let positionLen = currentMembers.length
            let countIndex = count
            selectedTeamMembers.map((member, index) => {
                const exists = currentMembers.some(item => item.approverId === member.approverId);
                if (!exists) {
                    const obj = {
                        key: countIndex,
                        branchId: member.branchId,
                        position: index,
                        approverId: member.approverId,
                        hockUserId: member.hockUserId,
                        permission: member.permission,
                        notification: member.notification,
                        approverName: member.approverName


                    }


                    countIndex++;
                    currentMembers.push(obj);
                }


            })
            const updatedMembers = currentMembers.map((item, index) => {
                let obj = item
                obj.position = index + 1
                return obj
            })
            for (const item of updatedMembers) {
                await updateHocuserList(item.approverId)
            }


            setCount(countIndex);
            setMembers(updatedMembers);
            checkCircularTypes([...selectedTeams,teamsTemp[0]],updatedMembers)

        }
        setIsMembersTableLoading(false)
    }




    const tagclose = (e) => {
        const updatedTeams = selectedTeams.filter(element => element._id !== e);
        setSelectedTeams(updatedTeams);
        const teamsTemp = selectedTeams.filter(element => element._id == e);
        const removeMembers = teamsTemp[0].members
        const currentMembers = [...members]
        let newMemberList = currentMembers;
        const updatedMembers = []
        updatedTeams.forEach((team) => {
            team.members.forEach((member) => {
                const obj = currentMembers.filter(element => element.approverId === member.approverId)
                // console.log(member,"member qqqqqqqqqqqqqqqqqqqqqqqqqqqq")
                if (obj.length > 0) {
                    updatedMembers.push(obj[0])
                }


            })


        })
        const filteredList = currentMembers.filter(
            (item) => !removeMembers.some((removeItem) => removeItem.approverId === item.approverId)
        );
        //   console.log(filteredList,"filteredList rrrrrrrrrrrrrrrrrrrrrrrrr")
        //   console.log(updatedMembers, "updatedTeams vvvvvvvvvvvvvvvvvvvvv" )


        const mergedList = [...updatedMembers, ...filteredList].reduce((acc, item) => {
            acc.set(item.approverId, item);
            return acc;
        }, new Map()).values();


        //   updatedMembers.map((member)=>{
        //     let exist = filteredList.some((item) => item.approverId === member.approverId)
        //     if(exist){


        //     }
        //   })


        const uniqueList = Array.from(mergedList);








        // console.log(updatedMembers,"updatedMembers xxxxxxxxxxxxwwwwwwwwwwwwww")


        // console.log(uniqueList,"uniqueList xxxxxxxxxxxxwwwwwwwwwwwwww")
        const positionedMemebrs = uniqueList.map((item, index) => {
            let obj = item
            obj.position = index + 1
            return obj
        })
        setMembers(positionedMemebrs);
        checkCircularTypes(updatedTeams,positionedMemebrs);


        // console.log(teamsTemp, "tag close vvvvvvvvvvvvvvvvvvvvv" )
    }

const checkCircularTypes =(teams,newMmberlist)=>{
        let status = true;
        let type=""
        if(teams.length>0){
            for(let team of teams){
                if(type!=""&&type!=team.circulationType){
                    status=false
                    break;
                }
                type=team.circulationType
            }
        }else{
            status = false;
        }
        
        if(status){
            let memberslist = []
            for(let team of teams){
                memberslist = [...memberslist,...team.members]
            }
            const list1Ids = new Set(newMmberlist.map(obj => obj.approverId)); // Store all ids of list1
            status = memberslist.every(obj => list1Ids.has(obj.approverId)); 
        }

        form.setFieldsValue({
            circulertype: type, // Setting the value of the "username" field
          });
        setTeamCreate({...teamCreate, circulationType : type})
        setDesableCircularType(status)
        
        }


    const handleAddUser = () => {
        const currentMem = [...members];
        const newRow = {
            key: count,
            branchId: "",
            position: currentMem.length + 1,
            approverId: "",
            // hocId: "",
            permission: "",
            notification: ['approve_reject', 'further_info', 'immediate_comment']
        };
        setCount(count + 1);
        setMembers([...members, newRow]); // Add new row to data source
        setDesableCircularType(false);

    };




    const gethocusersforId = async (approverId) => {
        const data = await RequestApproval.getAddHocUsers(approverId)
            .then((response) => {
                const usersList = response.data.map((element) => ({
                    id: element.signatoriesId._id,
                    name: element.signatoriesId.name,
                }));
                return usersList;
            })
            .catch((error) => {
                console.error("Error fetching users:", error);
                return [] // Handle error by resetting users
            })


        return data
    }


    const selectHocUser = (e, record, hocUsers) => {
        const user = hocUsers.filter(element => element.id === e);
        // console.log(user,"hoc users hocccccc userrrrrrrrrrrrrrrrrrrrrrr")
        const currentstate = [...members]
        let setted = currentstate.map((item) =>
            item.key === record.key
                ? {
                    ...item,
                    hockUserId: user[0].id
                }
                : item
        );


        setMembers(setted);
    }


    const onSelectApprover = async (e, record) => {
        console.log(record, "on select record");
        // console.log(e,"on select eeeeee");
        // form.resetFields([`hocUser${record.key}`]);
        form.setFieldsValue({ [`hocUser${record.key}`]: undefined })
        const user = allUsers.filter(element => element.id === e);
        console.log(user, "selected userrrrrrrrrrrrrrrrrrrrrrr")
        const currentstate = [...members]
        let setted = currentstate.map((item) =>
            item.key === record.key
                ? {
                    ...item,
                    approverId: user[0].id,
                    branchId: user[0].branchId,
                    approverName: user[0].name,
                    hockUserId: undefined
                }
                : item
        );




        // const list = hocUserLists[e]
        // console.log(list,"hoc user list")
        // if(list!==null){
        //     const hocusers = await gethocusersforId(e);
        //     setHocUserLists((prevHocUser) => ({
        //         ...prevHocUser,   // Keep existing properties
        //         [e]: hocusers,  // Dynamically add new property
        //       }))
        // }
        await updateHocuserList(e)


        setMembers(setted);


    }


    const updateHocuserList = async (e) => {
        const list = hocUserLists[e]
        console.log(list, "hoc user list")
        if (list !== null) {
            const hocusers = await gethocusersforId(e);
            setHocUserLists((prevHocUser) => ({
                ...prevHocUser,   // Keep existing properties
                [e]: hocusers,  // Dynamically add new property
            }))
        }
    }


    const onSelectAction = (e, record) => {
        const currentstate = [...members]
        let setted = currentstate.map((item) =>
            item.key === record.key
                ? {
                    ...item,
                    permission: e,
                }
                : item
        );
        setMembers(setted);
    }


    const onRemoveMember = (record) => {




        const data = members.filter(mem => mem.key !== record.key);
        const positionedMemebrs = data.map((item, index) => {
            let obj = item
            obj.position = index + 1
            return obj
        })


        setMembers(positionedMemebrs);
        checkCircularTypes(selectedTeams,positionedMemebrs);


    }


    const selectNotificationType = (e, record) => {
        // console.log(e,"selected notification type");
        // console.log(record,"selected record ");
        const currentstate = [...members]
        let setted = currentstate.map((item) =>
            item.key === record.key
                ? {
                    ...item,
                    notification: e,
                }
                : item
        );
        setMembers(setted);
    }




    const TableRow = (props) => {
        const {
            attributes,
            listeners,
            setNodeRef,
            setActivatorNodeRef,
            transform,
            transition,
            isDragging,
        } = useSortable({
            id: props['data-row-key'],
        });
        const style = {
            ...props.style,
            transform: CSS.Translate.toString(transform),
            transition,
            ...(isDragging
                ? {
                    position: 'relative',
                    zIndex: 9999,
                }
                : {}),
        };
        const contextValue = useMemo(
            () => ({
                setActivatorNodeRef,
                listeners,
            }),
            [setActivatorNodeRef, listeners],
        );
        return (
            <RowContext.Provider value={contextValue}>
                <tr {...props} ref={setNodeRef} style={style} {...attributes} />
            </RowContext.Provider>
        );
    };


    const DragHandle = () => {
        const { setActivatorNodeRef, listeners } = useContext(RowContext);
        return (
            <Button
                type="text"
                size="small"
                icon={<HolderOutlined />}
                style={{
                    cursor: 'move',
                }}
                ref={setActivatorNodeRef}
                {...listeners}
            />
        );
    };


    const onDragEnd = (event) => {
        const { active, over } = event;
        if (active.id !== over.id) {
            const oldIndex = members.findIndex((item) => item.key === active.id);
            const newIndex = members.findIndex((item) => item.key === over.id);


            const shuffledData = arrayMove(members, oldIndex, newIndex);
            const mapped = shuffledData.map((item, index) => {
                item.position = index + 1
                return item
            })
            setMembers(mapped);
        }
    };


    const actionOptions = ['Approve', 'View']


    const columns = [
        {
            title: "",
            dataIndex: "drag",
            width: 50,
            render: (_, record) => <DragHandle />,
        },
        {
            title: 'Action',
            dataIndex: 'actionOptions',
            key: 'action',
            width: 240,
            render: (_, record) => (
                // <Tooltip
                // title={validationErrors[`hocUser${record.key}`]}
                // color="red"
                // visible={!!validationErrors[`hocUser${record.key}`]}
                // >
                <Form.Item name={`action${record.key}`} initialValue={record.permission} style={{ marginBottom: 0 }} rules={[{ required: true, message: '' }]}>
                    <Select showSearch onSelect={(e) => onSelectAction(e, record)}>
                        {actionOptions.map((action, idx) => (
                            <Select.Option key={idx} value={action.toLowerCase()}>
                                {action}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                // </Tooltip>
            ),
        },
        {
            title: 'Name',
            dataIndex: 'approverName',
            key: 'approverName',
            width: 240,
            render: (_, record) => (
                <Form.Item name={`approver${record.key}`} initialValue={record.approverId} style={{ marginBottom: 0 }} rules={[{ required: true, message: '' }]}>
                    {/* <Select showSearch
                        filterOption={(input, option) =>
                            option.label && option.label.toLowerCase().includes(input.toLowerCase())
                        }
                        onSelect={(e)=>{onSelectApprover(e,record)}}
                    >
                    <Select.Option key={0} value={record.approverId}>
                                {record.approverName}
                        </Select.Option>
                        {availableUsers.map((option, id) => (
                            <Select.Option key={id+1} value={option.id}>
                            {option.name}
                            </Select.Option>
                            ))}
                           
                            </Select> */}
                    <Select
                        showSearch
                        filterOption={(input, option) =>
                            option.label && option.label.toLowerCase().includes(input.toLowerCase())
                        }
                        onSelect={(e) => onSelectApprover(e, record)}
                        options={[
                            { label: record.approverName, value: record.approverId }, // Default option
                            ...availableUsers.map((user) => ({
                                label: user.name,
                                value: user.id
                            }))
                        ]}
                    />
                </Form.Item>
            ),
        },
        {
            title: 'Alternate Signatory',
            dataIndex: 'hocId',
            key: 'user',
            width: 240,
            render: (_, record) => (
                <>
                    {record.approverId && hocUserLists[record.approverId].length > 0 && record.permission !== "view" ? (
                        <Form.Item key={record.approverId} name={`hocUser${record.key}`} initialValue={record.hockUserId} style={{ marginBottom: 0 }} >
                            <Select
                                defaultValue={record.hockUserId}
                                showSearch
                                onSelect={(e) => { selectHocUser(e, record, hocUserLists[record.approverId]) }}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                {hocUserLists[record.approverId].map((user, idx) => (
                                    <Select.Option key={idx} value={user.id}>
                                        {user.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    ) : (<></>)
                    }
                </>
            ),
        },
        {
            title: 'Notification',
            dataIndex: 'NotificationPermissions',
            key: 'Notification Permissions',
            render: (_, record) => (
                <Form.Item style={{ marginBottom: 0 }}>
                    <Select value={record.notification} onChange={(e) => { selectNotificationType(e, record) }} mode="multiple" placeholder="Select Notification type" showSearch>
                        <Option value="approve_reject">Appprove Reject</Option>
                        <Option value="further_info">Further Info</Option>
                        <Option value="immediate_comment">Immediate Comment</Option>
                        <Option value="consolidate_summary">Consolidate Summary</Option>
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: 100,
            align: 'center',
            render: (_, record) => (
                <Button type='primary' danger onClick={() => onRemoveMember(record)} icon={<DeleteOutlined />} />
            ),
        },
    ];


    return (
        <>
            {contextHolder}
            <div>
                <Form form={form} layout='vertical'>
                    <Row gutter={16}>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item initialValue={circularTypeFilter} label="Select Circular Type"  >
                                <Select value={circularTypeFilter} onChange={(e)=>{onFilterCircularType(e)}}>
                                    <Select.Option value="">All</Select.Option>
                                    <Select.Option value="parallel">Parallel</Select.Option>
                                    <Select.Option value="hierarchy">Hierarchical</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Form.Item label="Select Workflow">
                                <Select
                                    showSearch
                                    // onSearch={(e)=>{searchTemplate(e)}}
                                    onSelect={selectWorkflow}
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {companyTeams.map((item, index) => (
                                        <Select.Option key={index} value={item.id}>{item.name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                            <Flex align='center' justify='flex-start' gap={4}>
                                {selectedTeams.map((item) => (
                                    <Tag key={item._id} color="success" closable onClose={() => { tagclose(item._id) }}>{item.name}</Tag>
                                ))


                                }


                                {/* <Tag  color="success" closable>Tag 4</Tag>
                                <Tag  color="success" closable>Tag 5</Tag>
                                <Tag  color="success" closable>Tag 6</Tag> */}
                            </Flex>
                        </Col>
                    </Row>
                    <Divider/>
                    <Flex align='center' justify='flex-end' >
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={handleAddUser}
                        >
                            Add User
                        </Button>
                    </Flex>
                    <br/>
                    {showTeamNameField ?
                        <>
                            <Form.Item name={"worflowname"} initialValue={teamCreate.name} rules={[{ required: true, message: 'Please workflow title' }]}>
                                <Input value={teamCreate.name} onChange={onchangeTeamName} placeholder='Add Workflow Title' />
                            </Form.Item>
                        </> : <></>}


                    <div>
                        {isMembersTableLoading ? (<><CommonSkeletonLoader itemCount={1} /></>) : (<>
                            {members.length > 0 ? <>
                                <div>
                                <Form.Item name={"circulertype"} initialValue={teamCreate.circulationType} label="Circular Type" rules={[{required: true, message: 'Please Select Circular Type'}]} >
                                        <Select disabled={desableCircularType} value={teamCreate.circulationType} onChange={(e)=>{onchangeCircularType(e)}}>
                                            <Select.Option value="parallel">Parallel</Select.Option>
                                            <Select.Option value="hierarchy">Hierarchical</Select.Option>
                                        </Select>
                                    </Form.Item>
                                    <DndContext
                                        key={"dnd"}
                                        onDragEnd={onDragEnd}
                                        modifiers={[restrictToVerticalAxis]}


                                    >
                                        <SortableContext items={members.map((item) => item.key)} strategy={verticalListSortingStrategy}>


                                            <Table
                                                dataSource={members}
                                                columns={columns}
                                                pagination={false}
                                                rowKey="key"
                                                components={{
                                                    body: {
                                                        row: TableRow,
                                                    },
                                                }}
                                                scroll={{
                                                    x: 'max-content'
                                                }}
                                            />
                                        </SortableContext>
                                    </DndContext>
                                </div>
                            </> :  <>
                                <Table 
                                    // dataSource={members} 
                                    columns={columns} 
                                    pagination={false}
                                    rowKey="key"
                                    />
                                </>
                            }
                        </>)}
                    </div>
                </Form>




                <br />


            </div>
        </>
    );
});


export default CreateTeam;



